const metaFields = {
  meta_title: '',
  meta_h1: '',
  meta_description: '',
  meta_keywords: '',
  meta_sub_title: '',
};

export default {
  metaFields,
};



// WEBPACK FOOTER //
// ./src/helpers/metaData.helper.js